import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useShopEnabled() {
  const { data: enabled = true, isLoading } = useQuery({
    queryKey: ['platform-settings', 'shop_enabled'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('platform_settings')
        .select('value')
        .eq('key', 'shop_enabled')
        .maybeSingle();
      if (error) throw error;
      return data?.value === true;
    },
    staleTime: 5 * 60 * 1000,
  });
  return { shopEnabled: enabled, isLoading };
}

export function useToggleShopEnabled() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (enabled: boolean) => {
      const { error } = await supabase
        .from('platform_settings')
        .update({ value: enabled as any, updated_at: new Date().toISOString() })
        .eq('key', 'shop_enabled');
      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['platform-settings', 'shop_enabled'] });
    },
  });
}
export function useBibResaleEnabled() {
  const { data: enabled = true, isLoading } = useQuery({
    queryKey: ['platform-settings', 'bib_resale_enabled'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('platform_settings')
        .select('value')
        .eq('key', 'bib_resale_enabled')
        .maybeSingle();
      if (error) throw error;
      // Par défaut activé si la clé n'existe pas
      if (!data) return true;
      return data.value === true;
    },
    staleTime: 5 * 60 * 1000,
  });
  return { bibResaleEnabled: enabled, isLoading };
}

export function useToggleBibResaleEnabled() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (enabled: boolean) => {
      // Upsert pour que ça marche même si la ligne n'a jamais été créée
      const { error } = await supabase
        .from('platform_settings')
        .upsert(
          { key: 'bib_resale_enabled', value: enabled as any, updated_at: new Date().toISOString() },
          { onConflict: 'key' },
        );
      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['platform-settings', 'bib_resale_enabled'] });
    },
  });
}
